<template>
  <div class="vx-row">

    <!-- HORIZONTAL LAYOUT -->
    <div class="vx-col w-full mb-base">
      <vx-card title="餐卷銷售" code-toggler>
        <div class="vx-row mb-12">
          <div class="vx-col sm:w-1/3 w-full">
            <span>客戶名稱</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input v-validate="'required'" name="ClientName" class="w-full" v-model="ClientName" />
            <span class="text-danger text-sm" v-show="errors.has('ClientName')">客戶名稱必填</span>
          </div>
        </div>
        <div class="vx-row mb-12">
          <div class="vx-col sm:w-1/3 w-full">
            <span>客戶電話</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input v-validate="'required'" name="ClientPhone" class="w-full" v-model="ClientPhone" />
            <span class="text-danger text-sm" v-show="errors.has('ClientPhone')">客戶電話必填</span>
          </div>
        </div>

        <div class="vx-row mb-12">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Email</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" type="email" v-model="ClientEmail" />
          </div>
        </div>
        <div class="vx-row mb-12">
          <div class="vx-col sm:w-1/3 w-full">
            <span>票卷5000NT 票卷數量為偶數</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
              <vs-input v-validate="'required'" type="string" :min="1" :max="99999" name="TickerNumber" label="起始票卷號碼" placeholder=" 起始票卷號碼 完整的號碼 EX:R0F1090727C00001" class="w-full" v-model="TickerNumber" />
              <span class="text-danger text-sm" v-show="errors.has('TickerNumber')">起始票卷號碼必填</span>
              <vs-input-number label="請填票卷數量" min="0" max="100" v-model="TicketAmount" />
              <vs-textarea label="票卷號碼" v-model="TicketNumberList" />
          </div>
        </div>
        <div class="vx-row mb-12">
          <div class="vx-col sm:w-1/3 w-full">
            <span>統一發票號碼</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input v-validate="'required'" name="invoice" class="w-full" v-model="invoice" />
            <span class="text-danger text-sm" v-show="errors.has('invoice')">統一發票號碼必填</span>
          </div>
        </div>

        <div class="vx-row mb-12">
          <div class="vx-col sm:w-1/3 w-full">
            <span>總價</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input disabled class="w-full" v-model="order_price" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-2/3 w-full ml-auto">
            <vs-button class="mr-3 mb-2" @click="saveTicketOrder">送出訂單</vs-button>
          </div>
        </div>

      </vx-card>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export default{
  data () {
    return {
      ClientName: '',
      ClientPhone: '',
      ClientEmail: '',
      TicketAmount:0,
      TicketNumberList: [],
      TickerNumber: '',
      defaultTicketNumber: '',
      defaultTicketDigits: 5,
      defaultTicketDigitsString: '',
      order_price:0,
      order_number:'',
      invoice:'',
      userInfo:{},
      ticker_name:'龍蝦餐券'
    }
  },
  methods: {
    saveTicketOrder () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const db = firebase.firestore()
          const counters = db.collection('counters').doc('ticket')
          // 先拿單號
          counters.get().then((doc) => {
            if (doc.exists) {
              this.order_number = doc.data().count
              console.log(this.order_number)
              // 送出訂單
              const ticket_order_ref = db.collection('ticket_order').doc((this.order_number).toString())
              ticket_order_ref.set({
                id:this.order_number,
                ClientName:this.ClientName,
                ClientPhone:this.ClientPhone,
                ClientEmail:this.ClientEmail,
                TicketAmount:this.TicketAmount,
                TicketNumberList:this.TicketNumberList,
                invoice:this.invoice,
                order_price:this.order_price,
                status:'訂單成立',
                sales:this.userInfo.name,
                store:this.userInfo.store,
                ticker_name:this.ticker_name
              })
              console.log('以送出訂單')
              // 單號新增
              counters.update({
                count: parseInt(this.order_number) + 1
              })
              alert('訂單已送出')
              // setTimeout(window.location.reload(), 2000)
              this.ClientName = ''
              this.ClientPhone = ''
              this.ClientEmail = ''
              this.TicketAmount = 0
              this.TicketNumberList = []
              this.TickerNumber = ''
              this.defaultTicketNumber = ''
              this.defaultTicketDigits = 5
              this.defaultTicketDigitsString = ''
              this.order_price = 0
              this.order_number = ''
              this.invoice = ''

            }
          }).catch(function (error) {
            console.log('Error getting document:', error)
          })

        } else {
          // form have errors
        }
      })
    }
  },
  watch: {
    TicketAmount (val) {
      this.TicketNumberList = []
      let TempTicketNumber = ''
      let StringTickerNumber = ''
      console.log(this.TickerNumber.toUpperCase().split('C'))
      this.defaultTicketNumber = this.TickerNumber.toUpperCase().split('C')[0]
      for (let i = 0; i < val; i++) {
        TempTicketNumber = parseInt(this.TickerNumber.toUpperCase().split('C')[1]) + parseInt(i)
        StringTickerNumber = this.defaultTicketDigitsString + TempTicketNumber
        StringTickerNumber = (`00000${  StringTickerNumber}`).slice(-5)
        this.TicketNumberList.push(`${this.defaultTicketNumber  }C${ StringTickerNumber}`)
      }
      this.order_price = 5000 * val
      console.log(this.order_price)
    }
  },
  created () {
    for (let i = 0; i < this.defaultTicketDigits; i++) {
      this.defaultTicketDigitsString += '0'
    }
    const user = firebase.auth().currentUser
    const db = firebase.firestore()
    const userRef = db.collection('user').doc(user.uid)

    // 檢查是否在資料庫內
    userRef.get().then((doc) => {
      if (doc.exists) {
        const getUserData = doc.data()
        this.userInfo = getUserData
      } else {
        console.log('no user')
      }
    }).catch(function (error) {
      console.log('Error getting document:', error)
    })
  }

}
</script>
